/**
 * Nest JSON 파싱 오류(`Expected property name...`) 디버깅용:
 * - 이중 JSON.stringify 방지
 * - 개발 모드에서 본문 BOM·프리뷰·파싱 가능 여부 로깅
 */


const isDev = process.env.NODE_ENV === 'development';

/** User-Agent로 대략적인 클라이언트 구분 (Nest 로그와 대조) */
export function guessHttpClientKind(userAgent: string): string {
  if (!userAgent || userAgent === '(non-browser)') return 'unknown';
  if (/PostmanRuntime/i.test(userAgent)) return 'Postman';
  if (/insomnia/i.test(userAgent)) return 'Insomnia';
  if (/curl/i.test(userAgent)) return 'curl';
  if (/okhttp/i.test(userAgent)) return 'okhttp';
  if (/Mozilla/i.test(userAgent)) return 'browser';
  return 'other';
}

function logDevOutgoingBody(_body: string, _label: string): void {
  if (!isDev) return;
}

/**
 * POST/PUT/PATCH/DELETE JSON 본문 직렬화.
 * 문자열을 넘기면 이미 JSON 텍스트로 간주하고 그대로 보냄(이중 stringify 방지).
 */
export function serializeJsonRequestBody(data: unknown): string | undefined {
  if (data === undefined || data === null) return undefined;
  if (data instanceof FormData) {
    throw new Error('serializeJsonRequestBody: FormData는 호출부에서 body로 직접 넘기세요.');
  }
  if (typeof data === 'string') {
    logDevOutgoingBody(data, 'outgoing JSON body (string)');
    return data;
  }
  const s = JSON.stringify(data);
  logDevOutgoingBody(s, 'outgoing JSON body (object)');
  return s;
}
